import React from 'react';
import './styles/Register.css';
import { Link } from 'react-router-dom';
import { useState, useRef } from "react";
import { FaUpload } from "react-icons/fa";
import Select from "react-select";
import { useSWRConfig } from "swr";
import Swal from 'sweetalert2';

const defaultImageBase64 = "data:image/png;base64,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";


const tematicas = [
    {value: "Programación", label: "Programación"},
    {value: "Programación web", label: "Programación web"},
    {value: "Programación de aplicaciones móviles", label: "Programación de aplicaciones móviles"},
    {value: "Lenguajes de programación", label: "Lenguajes de programación"},
    {value: "Java", label: "Java"},
    {value: "C++", label: "C++"},
    {value: "Python", label: "Python"},
    {value: "JavaScript", label: "JavaScript"},
    {value: "Php", label: "Php"},
    {value: "IA", label: "IA"},
    {value: "Emprendimiento", label: "Emprendimiento"},
    {value: "Comunicación", label: "Comunicación"},
    {value: "Ventas", label: "Ventas"},
    {value: "Negocios", label: "Negocios"},
    {value: "Gestión de Proyectos", label: "Gestión de Proyectos"},
    {value: "Recursos Humanos", label: "Recursos Humanos"},
    {value: "Comercio electrónico", label: "Comercio electrónico"},
    {value: "Contabilidad", label: "Contabilidad"},
    {value: "Finanzas", label: "Finanzas"},
    {value: "Economía", label: "Economía"},
    {value: "Inversión", label: "Inversión"},
    {value: "Informática", label: "Informática"},
    {value: "Ofimática", label: "Ofimática"},
    {value: "Hardware", label: "Hardware"},
    {value: "Desarrollo Personal", label: "Desarrollo Personal"},
    {value: "Diseño", label: "Diseño"},
    {value: "Diseño Gráfico", label: "Diseño Gráfico"},
    {value: "Diseño 3D y animación", label: "Diseño 3D y animación"},
    {value: "Diseño de moda", label: "Diseño de moda"},
    {value: "Diseño arquitectónico", label: "Diseño arquitectónico"},
    {value: "Diseño de interiores", label: "Diseño de interiores"},
    {value: "Marketing", label: "Marketing"},
    {value: "Marketing digital", label: "Marketing digital"},
    {value: "Marca personal", label: "Marca personal"},
    {value: "Arte y manualidades", label: "Arte y manualidades"},
    {value: "Pintura", label: "Pintura"},
    {value: "Dibujo", label: "Dibujo"},
    {value: "Cocina", label: "Cocina"},
    {value: "Fotografía y vídeo", label: "Fotografía y vídeo"},
    {value: "Nutrición", label: "Nutrición"},
    {value: "Deporte y fitness", label: "Deporte y fitness"},
    {value: "Música", label: "Música"},
    {value: "Ingeniería", label: "Ingeniería"},
    {value: "Humanidades", label: "Humanidades"},
    {value: "Filosofía", label: "Filosofía"},
    {value: "Lengua y literatura", label: "Lengua y literatura"},
    {value: "Matemáticas", label: "Matemáticas"},
    {value: "Ciencia", label: "Ciencia"},
    {value: "Física", label: "Física"},
    {value: "Química", label: "Química"},
    {value: "Biología", label: "Biología"},
    {value: "Geología", label: "Geología"},
    {value: "Ciencias Sociales", label: "Ciencias Sociales"},
    {value: "Psicología", label: "Psicología"},
    {value: "Historia", label: "Historia"},
    {value: "Historia del arte", label: "Historia del arte"},
    {value: "Geografía", label: "Geografía"},
    {value: "Idiomas", label: "Idiomas"},
    {value: "Idioma Inglés", label: "Idioma Inglés"},
    {value: "Idioma Español", label: "Idioma Español"},
    {value: "Idioma Francés", label: "Idioma Francés"},
    {value: "Idioma Alemán", label: "Idioma Alemán"},
    {value: "Idioma Ruso", label: "Idioma Ruso"},
    {value: "Idioma Chino", label: "Idioma Chino"},
    {value: "Idioma Árabe", label: "Idioma Árabe"},
    {value: "Idioma Japonés", label: "Idioma Japonés"},
    {value: "Formación de profesorado", label: "Formación de profesorado"},
    {value: "Preparación para examenes oficiales", label: "Preparación para examenes oficiales"},
];

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%", // Ancho completo
      height: "50px", // Altura fija
      background: 'transparent',
      border: '2px solid var(--border-color)',
      borderRadius: '40px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(255, 255, 255, 0.5)' : 'none',
      fontSize: '16px',
      maxHeight: '70px', // Altura máxima del Select
      overflowY: 'auto', // Permite desplazamiento interno
      color: '#000',
      '&:hover': {
        borderColor: 'var(--border-color)',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#000', // Cambiar el color del texto
    }),
    input: (provided) => ({
      ...provided,
      color: '#000', // Color del texto mientras se escribe
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--text-principal)', // Color del placeholder
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',        // color de la flecha
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: 'var(--color-selectIcons)',  
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'var(--color-opcionseleccionada)', 
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'var(--textButtonHome)',                                  
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
      color: '#000',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.3)',
      },
    }),
    ValueContainer: (provided) => ({
        ...provided,
        maxHeight: '10px', // Limita la altura del contenedor de valores seleccionados
        overflowY: 'auto', // Habilitar desplazamiento dentro del contenedor
    }),
  };

  let baseUrl;
  if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
  else baseUrl='https://app-formacion.vercel.app';

  //Validaciones asíncronas
  export async function disponibilidad(input){
    //Hacer get con correo
    try{
      const response = await fetch(`${baseUrl}/api/users/search/${input}`, {
          method: "GET",
          headers: {
          'Content-Type': 'application/json', 
          },
      });

      return !response.ok; //Si no es correcto (no ok), el email está disponible
      
    } catch (error) {
      return false;
    }  
  }

  
const RegisterForm = () => {
    const { mutate } = useSWRConfig();
    
    //Seleccionar valores del formulario
    const [formData, setFormData] = useState({
      Id_Mensaje: [],
      Nombre: "",
      Apellidos: "",
      Usuario: "",
      Contrasenna: "",
      Contrasenna2: "",
      Correo: "",
      FechaNacimiento: new Date(),
      Tipo: "",
      ImagenPerfil: "",
      Tematicas: [],
      FechaCreacion: new Date(),
    });
    
    //Modificar el botón según el radio button elegido
    const [buttonState, setButtonState] = useState({
        text: "Registrarse",
    });

    //Manejador del cambio en el radio button y modificar botón según valor
    const handleRadioChange = (event) => {
        const value = event.target.value;
        setFormData({...formData, Tipo: value})

        if(value === "Cliente"){
            setButtonState({
                text: "Registrarse",
            });
        }
        else if(value === "Tutor"){
            setButtonState({
                text: "Pasar al pago",
            });
        }
        else{   //Si no está seleccionado ninguno se mostrará el botón registrarse
            setButtonState({
                text: "Registrarse",
            });
        }
    };

    //Select (multiples opciones)
    const [selectedOptions, setSelectedOptions] = useState([]);
    const handleSelect = (selectedOption) => {
        setSelectedOptions(selectedOption);
        setFormData({ ...formData, Tematicas: selectedOption.map((opt) => opt.value) });
    };

    //Manejador de cambios en campos de entrada
    const handleChange = (e) => {
      setFormData({...formData, [e.target.name]: e.target.value });
    };
    
    //Manejar cambio de archivo de imagen
    const [image, setImage] = useState(null);
    const [nombreImagen, setNombreImagen] = useState("");
    const fileInputRef = useRef(null); // Referencia al input file

    // Manejar el cambio de archivo
    const handleImageChange = (e) => {
      const file = e.target.files[0]; // Solo tomamos el primer archivo
      if (file) {
        const reader = new FileReader();
        setNombreImagen(file.name);
        reader.readAsDataURL(file); // Convertir imagen a Base64
        reader.onloadend = () => {
          const base64String = reader.result.split(',')[1]; // Extraer solo los datos base64
          setImage(base64String); // Almacenamos el archivo en el estado
        };
      }
    };

    //Eliminar imagen seleccionada
    const handleEliminarArchivo = () => {
      setNombreImagen("");
      setImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Restablece el input file
      }
    };

    //Enviar datos a la API 
    const handleSubmit = async (e) => {
      e.preventDefault(); //Evitar recargar página

      //Si el usuario no ha seleccionado imagen, se utilizará una por defecto
      const finalImage = image ? image : defaultImageBase64;

      if (!formData.Tipo) {
        setTipoUsuario({ value: "", hasErrorTipo: true });
        return;
      }

      if (formData.Tipo === "Tutor" && selectedOptions.length === 0) {
        document.getElementById('errorTematicas').style.visibility = 'visible';
        document
          .getElementById('errorTematicas')
          .scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      //Verificar que no existen errores:
      if (
        nombre.hasErrorNombre ||
        apellidos.hasErrorApellidos ||
        usuario.hasErrorUsuario ||
        !usuario.usuarioDisp ||
        contrasenna.hasErrorContrasenna ||
        contrasenna2.hasErrorContrasenna2 ||
        email.hasErrorEmail ||
        !email.emailDisp ||
        fecha.hasErrorfechaNac ||
        tipoUsuario.hasErrorTipo 
      ) {
        Swal.fire({
          icon: 'warning',
          title: 'Formulario inválido',
          text: 'Por favor, corrija los errores en el formulario.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      //Preparar objeto con los datos del usuario
      const dataToSend = {
        Id_Mensaje: [],
        Nombre: e.target.Nombre.value,
        Apellidos: e.target.Apellidos.value,
        Usuario: e.target.Usuario.value,
        Contrasenna: e.target.Contrasenna.value,
        Correo: e.target.Correo.value,
        FechaNacimiento: e.target.FechaNacimiento.value,
        Tipo: e.target.Tipo.value,
        ImagenPerfil: finalImage,
        FechaCreacion: new Date(),
        Tematicas: selectedOptions.map((opt) => opt.value)
      };

      if(dataToSend.Tipo === "Cliente"){
        try{
          const response = await fetch(`${baseUrl}/api/users`, {
            method: "POST",
            headers: {'Content-Type': 'application/json', 
            },
            body: JSON.stringify(dataToSend),
          });

          // Verificar si la respuesta es exitosa
          if (!response.ok) {
            throw new Error("Error en la respuesta del servidor");
          }
          await Swal.fire({
            icon: 'success',
            title: '¡Usuario registrado!',
            text: 'Usuario registrado exitosamente.',
            confirmButtonText: 'Aceptar'
          });

          await mutate([`${baseUrl}/api/users?Tipo=Tutor`,
                      `${baseUrl}/api/clases/`,
                      `${baseUrl}/api/cursos/`,
                      `${baseUrl}/api/resennas/`
                  ]
          );
        
        //Iniciar sesión

          try{
            const response = await fetch(`${baseUrl}/api/users/search/${e.target.Correo.value}`, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            });

            const user = await response.json();
            localStorage.setItem("userLogueado", JSON.stringify(user));

            if(user.Tipo === "Cliente") window.location.href = "/cliente";
            //if(user.Tipo === "tutor") window.location.href = "/tutor";
            //else window.location.href = "/"; //Modificar por admin
            
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Error de inicio de sesión',
              text: 'No se pudo iniciar sesión',
              confirmButtonText: 'Aceptar'
            });
            console.error(error);
          } 


        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error al registrar',
            text: 'Hubo un error al registrar el usuario.',
            confirmButtonText: 'Aceptar'
          });
          console.error(error);
        }
        return;
      }

      //Tutor
      if(dataToSend.Tipo === "Tutor"){
        try{
          localStorage.setItem("tutorPendiente", JSON.stringify(dataToSend));


          //Llamar al endpoint para crear sesión de pago de subscripción, pasamos como usuarioId el Usuario del tutor (es único) ya que no existe _id
          const responseSub = await fetch(`${baseUrl}/api/pago/crear-subscripcion`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                usuarioId: dataToSend.Usuario,
                moneda: "eur",
              }),
            }
          );

          if(!responseSub.ok) throw new Error("Error creando la sesión de Stripe");
          
          const { url } = await responseSub.json();
          window.location.href = url;
        } catch(error){
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error de inicio de sesión',
            text: 'No se pudo iniciar sesión',
            confirmButtonText: 'Aceptar'
          });
        }
        return;
      }
    }

  /////////////////Validaciones//////////////////////
  const emailRegExp = new RegExp(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/);
  const nombreRegExp = new RegExp(/^[A-Za-zÁÉÍÓÚáéíóúÑñ]+(?:[-' ][A-Za-zÁÉÍÓÚáéíóúÑñ]+)*$/);
  const apellidosRegExp = new RegExp(/^[A-Za-zÁÉÍÓÚáéíóúÑñ]+(?:[-' ][A-Za-zÁÉÍÓÚáéíóúÑñ]+)*$/);
  const usuarioRegExp = new RegExp(/^(?!admin$)(?!administrador$)(?!sistema$)[a-zA-Z0-9_]{4,15}$/i);
  const contrasennaRegExp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/);

  //Nombre
  const [nombre, setNombre] = React.useState({
    value: "",
    hasErrorNombre: false,
  });

  //Apellidos
  const [apellidos, setApellidos] = React.useState({
    value: "",
    hasErrorApellidos: false,
  });

  //Usuario
  const [usuario, setUsuario] = React.useState({
    value: "",
    hasErrorUsuario: false,
    usuarioDisp: true,
  });

  //Contrasenna
  const [contrasenna, setContrasenna] = React.useState({
    value: "",
    hasErrorContrasenna: false,
  });

  //Contrasenna2
  const [contrasenna2, setContrasenna2] = React.useState({
    value: "",
    hasErrorContrasenna2: false,
  });

  //Email
  const [email, setEmail] = React.useState({
    value: "",
    hasErrorEmail: false,
    emailDisp: true,
  });

  const [tipoUsuario, setTipoUsuario] = React.useState({
    value: "",
    hasErrorTipo: false,
  });

  //Fecha Nacimiento
  const [fecha, setFecha] = React.useState({
    value: "",
    hasErrorfechaNac: false,
  });

  //Validaciones
  const handleBlur = async (e) => {
    const campo = e.target.name;
    const value = e.target.value.trim();

    //Error Nombre y Error Apellidos
    //Permite letras mayúsculas y minúsculas. Permite vocales con tilde (ÁÉÍÓÚáéíóú), permite la letra ñ (Ññ).
    //permite espacios entre nombres (pero no al inicio ni al final).
    //permite guiones (-) para nombres como "Jean-Pierre".
    // permite apóstrofes (') para nombres como "O’Reilly".
    // no permite caracteres especiales (@, #, $, etc.), números ni espacios dobles o mal ubicados.
    if(campo === "Nombre"){
      const NombreError = !nombreRegExp.test(value);
      setNombre((prev) => ({...prev, hasErrorNombre: NombreError}))
    }

    if(campo === "Apellidos"){
      const ApellidoError = !apellidosRegExp.test(value);
      setApellidos((prev) => ({...prev, hasErrorApellidos: ApellidoError}))
    }

    //Error Usuario
    //Entre 4 y 15 caracteres.
    //Solo permite letras (A-Z, a-z), números (0-9) y guiones bajos _.
    //No puede contener espacios, guiones medios (-) ni otros símbolos.
    // No puede ser "Admin" ni "Administrador" (en mayúsculas o minúsculas).
   if(campo === "Usuario"){
    const UsuarioError = !usuarioRegExp.test(value);
    setUsuario((prev) => ({ ...prev, hasErrorUsuario: UsuarioError }));

    // Validación asíncrona del nombre de usuario
    if(!UsuarioError){
        const disp = await disponibilidad(value);
        setUsuario((prev) => ({ ...prev, usuarioDisp: disp }));
    }
   }
   
   if(campo === "Correo"){
    const EmailError = !emailRegExp.test(value);
    setEmail((prev) => ({ ...prev, hasErrorEmail: EmailError }));

    if(!EmailError){
      // Validación asíncrona del correo electrónico
      const disp = await disponibilidad(value);
      setEmail((prev) => ({ ...prev, emailDisp: disp }));
    }
   }
    
    //Error Contrasenna. 
    //Mínimo 6 caracteres.
    //Al menos una letra mayúscula, al menos una letra minúscula.
    //Al menos un número. 
    // Puede contener caracteres especiales, pero no son obligatorios.
    if(campo === "Contrasenna"){
      const ContrasennaError = !contrasennaRegExp.test(value);
      setContrasenna((prev) => ({ ...prev, hasErrorContrasenna: ContrasennaError }));
      setFormData({...formData, Contrasenna: value});
    }

    //Error Contrasenna2. Contrasenna2 tiene que ser igual que contrasenna
    if(campo === "Contrasenna2"){
      let ContrasennaError2;
      if(formData.Contrasenna !== value) ContrasennaError2=true;
      else ContrasennaError2=false;
      setContrasenna2((prev) => ({ ...prev, hasErrorContrasenna2: ContrasennaError2 }));
    }

    //Error Fecha. No puede ser un valor futuro
    if(campo === "FechaNacimiento"){
      const fechaActual = new Date();
      const FechaError = new Date(fecha.value) > fechaActual;
      setFecha((prev) => ({...prev, hasErrorfechaNac: FechaError }));
    }

    //Error Tipo. Hay que elegir un valor
    if(campo === "Tipo"){
      const TipoError = value === "";
      setTipoUsuario((prev) => ({ ...prev, hasErrorTipo: TipoError }));
    }
    
  }

    return (
        <div className='register'>
            <div className='wrapperRegister'>
                <form onSubmit={handleSubmit}>
                    <h1>Registro</h1>
                    <div className="input-boxR">
                        <input type="text" name="Nombre" placeholder='Nombre' onChange={handleChange} onBlur={handleBlur} 
                        aria-errormessage="NombreErrorID"
                        aria-invalid={nombre.hasErrorNombre}
                        required />
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{marginLeft: "30px", visibility: nombre.hasErrorNombre ? "visible" : "hidden" }}
                        >
                          Por favor, introduzca un nombre válido
                        </p>
                    </div>
                    <div className="input-boxR">
                        <input type="text" name="Apellidos" placeholder='Apellidos' onChange={handleChange} onBlur={handleBlur}
                        aria-errormessage="ApellidosErrorID"
                        aria-invalid={apellidos.hasErrorApellidos}
                        required />
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{marginLeft: "30px", visibility: apellidos.hasErrorApellidos ? "visible" : "hidden" }}
                        >
                          Por favor, introduzca un Apellido válido
                        </p>
                    </div>
                    <div className="input-boxR" style={{ marginBottom: "50px" }}>
                        <label style={{padding: "0px 1px 0px 15px"}}>Selecciona tu fecha de nacimiento</label>
                        <input type="date" id='FechaNacimientoRegister' name="FechaNacimiento" placeholder='Fecha de Nacimiento' onChange={handleChange} onBlur={handleBlur}
                        aria-errormessage="FechaErrorID"
                        aria-invalid={fecha.hasErrorfechaNac}
                        required />
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{marginLeft: "30px", visibility: fecha.hasErrorfechaNac ? "visible" : "hidden" }}
                        >
                          Por favor, introduzca una Fecha de Nacimiento válida
                        </p>
                    </div>
                    <div className="input-boxR">
                        <input type="text" name="Usuario" placeholder="Nombre de usuario" onChange={handleChange} onBlur={handleBlur}
                        aria-errormessage="UsuarioErrorID"
                        aria-invalid={usuario.hasErrorUsuario || !usuario.usuarioDisp}
                        required/>
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{ marginLeft: "30px", visibility: usuario.hasErrorUsuario || !usuario.usuarioDisp ? "visible" : "hidden" }}
                        >
                          {usuario.hasErrorUsuario ? "Por favor, introduzca un usuario válido" : "Nombre de usuario no disponible"}
                        </p>
                    </div>
                    <div className="input-boxR">
                        <input type="email" name="Correo" placeholder="Email" onChange={handleChange} onBlur={handleBlur}
                        aria-errormessage="EmailErrorID"
                        aria-invalid={email.hasErrorEmail || !email.emailDisp}
                        required/>
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{marginLeft: "30px", visibility: email.hasErrorEmail || !email.emailDisp ? "visible" : "hidden" }}
                        >
                          {email.hasErrorEmail ? "Por favor, introduzca un correo válido" : "Este correo ya está regitrado"}
                        </p>
                    </div>
                    <div className="input-boxR" style={{marginBottom: "50px"}}>
                        <input type="password" name="Contrasenna" placeholder='Contraseña' onChange={handleChange} onBlur={handleBlur}
                        aria-errormessage="ContrasennaErrorID"
                        aria-invalid={contrasenna.hasErrorContrasenna}
                        required />
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{ marginLeft: "30px", visibility: contrasenna.hasErrorContrasenna ? "visible" : "hidden" }}
                        >
                          Por favor, introduzca una contraseña válida ( Mínimo 6 caracteres, al menos una mayúscula, una letra minúscula y un número. )
                        </p>
                    </div>
                    <div className="input-boxR">
                        <input type="password" name="Contrasenna2" placeholder='Confirmar contraseña' onChange={handleChange} onBlur={handleBlur}
                        aria-errormessage="Contrasenna2ErrorID"
                        aria-invalid={contrasenna2.hasErrorContrasenna2}
                        required />
                        <p
                          className="msgID"
                          aria-live='assertive'
                          style={{marginLeft: "30px", visibility: contrasenna2.hasErrorContrasenna2 ? "visible" : "hidden" }}
                        >
                          Las constraseñas introducidas no coinciden 
                        </p>
                    </div>

                    <div style={{display: "flex", flexDirection: "column", width: "100%", padding: "0px 1px 0px 15px"}}><label>Tipo de usuario</label></div>
                    <div className="input-radioR">
                        <input type="radio" id="cliente" name="Tipo" value="Cliente" onChange={(e) => { handleRadioChange(e); handleBlur(e); }} 
                        aria-errormessage="TipoUsuarioID"
                        aria-invalid={tipoUsuario.hasErrorTipo}
                        />
                        <label htmlFor="cliente">Cliente</label>
                        <input type="radio" id="tutor" name="Tipo" value="Tutor" onChange={(e) => { handleRadioChange(e); handleBlur(e); }}
                        aria-errormessage="TipoUsuarioID"
                        aria-invalid={tipoUsuario.hasErrorTipo}
                        />
                        <label htmlFor="tutor">Tutor</label>
                    </div>
                    <p
                          className="msgID"
                          aria-live='assertive'
                          style={{ marginLeft: "30px", visibility: tipoUsuario.hasErrorTipo ? "visible" : "hidden" }}
                    >
                          Debe elegir un tipo de usuario 
                    </p>

                    <div className="input-tematicasR">
                        <label style={{padding: "0px 1px 0px 15px"}}>¿Cuáles son tus intereses?</label>
                        <Select 
                            options={tematicas}
                            value={selectedOptions}
                            onChange={handleSelect}
                            isMulti={true}
                            styles={customStyles}
                            placeholder="Seleccione los temas que desee"
                        />
                        <p
                          id="errorTematicas"
                          className="msgID"
                          aria-live="assertive"
                          style={{
                            marginLeft: "30px",
                            color: "#c00",
                            visibility: "hidden",       
                            marginTop: "0.5rem"
                          }}
                        >
                          Debe seleccionar al menos una temática
                        </p>
                    </div>

                    <div className="input-box-fileR">
                        <label htmlFor="input_file" className='input_label_fileR'>Subir imagen de perfil</label>
                        <input type="file" placeholder='Subir Imagen' id="input_file" accept='image/*' onChange={handleImageChange} ref={fileInputRef} hidden/>
                        <FaUpload  className="icons"/>

                        {nombreImagen && ( // Muestra el nombre del archivo si se seleccionó uno
                          <div style={{  display: "flex", flexDirection: "row", alignItems: "center", width:"100%"}}>
                            <p style={{ color: 'var(--text-principal)', marginLeft:"10px" }}>
                              Archivo seleccionado: {nombreImagen}
                            </p>

                            <button onClick={handleEliminarArchivo} style={{background: "transparent", color: 'var(--text-principal)', border: "none", cursor: "pointer", borderRadius: "5px", width:"10px", height:"10px", marginLeft:"10px"}}>
                              X
                            </button>
                          </div>
                        )}
                    </div>

                
                    <button type="submit">{buttonState.text}</button>
                 

                    <div className="login-linkR">
                        <p>¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link></p>
                    </div>
                </form> 
            </div>
        </div>
    );
};

export default RegisterForm;

